import { render, staticRenderFns } from "./mdTalkList.vue?vue&type=template&id=5b95972a&scoped=true&"
import script from "./mdTalkList.vue?vue&type=script&lang=js&"
export * from "./mdTalkList.vue?vue&type=script&lang=js&"
import style0 from "./mdTalkList.vue?vue&type=style&index=0&id=5b95972a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b95972a",
  null
  
)

export default component.exports